<app-table
    [items]="data()"
    [columns]="columns()"
    translatePrefix="folderMedication.widget."
    prefix=""
    [hideCheckboxes]="true"
    [smallButtons]="true"
>
    <ng-template pTemplate="medicine" let-item="item">
        @if (item.customMedication) {
            <span>{{ item.customMedicationName }}</span>
        }
        <app-medication-info [medicationCode]="item.medicationCode"></app-medication-info>
    </ng-template>

    <ng-template pTemplate="stock" let-item="item">
        <app-button
            [text]="true"
            [label]="(item | countDaysDiff) | formatDaysDiff"
            [severity]="((item | countDaysDiff) <= 0
                ? 'danger'
                : ((item | countDaysDiff) < 7
                    ? 'warn'
                    : 'success'
                )
            )"
        ></app-button>
    </ng-template>
</app-table>
